import { render, staticRenderFns } from "./Lang.vue?vue&type=template&id=d968213a&"
import script from "./Lang.vue?vue&type=script&lang=js&"
export * from "./Lang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports